var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[_vm.size, 'button imitation'],on:{"click":function($event){$event.stopPropagation();return _vm.impersonate()}}},[_vm._m(0),_c('span',[_vm._v("\n        "+_vm._s(_vm.siteId != null ? 'Apotheke' : _vm.manufacturerId != null
            ? 'Industriepartner'
            : '')+"\n        imitieren\n    ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"icon-ak-industry-view"})])
}]

export { render, staticRenderFns }